export const ITEMS_PER_PAGE_DATA_TABLE = 50;
export const XDM_ITEM_WITH_AMOUNT_LENGTH = 3;
